<template>
  <section class="brands_screen_vidget">
    <span class="close_btn" @click="hideBrands">
      <span class="textHide">
        <span>{{ $t('header.menuClose') }}</span>
      </span>
    </span>

    <span class="br_list_title">
      <span class="textHide">
        <span>{{ $t('brands.all_brands') }}</span>
      </span>
    </span>
    <div class="br_list_container br_list_wrp">
      <div class="br_lisr_cont_wrap textFade">
        <div class="brnd_item" v-for="(item, index) in brandsArr" :key="item">
          <i :class="item"></i>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      brandsArr: [
        "icon-b_haylou",
        "icon-b_70mai",
        "icon-b_aqara",
        "icon-b_amaz",
        "icon-b_yi",
        "icon-b_oclean",
        "icon-b_mi",
        "icon-b_soocas",
        "icon-b_garmin",
        "icon-b_harman",
        "icon-b_smartmi",
        "icon-b_roborock",
        "icon-b_jbl",
        "icon-b_marshall",
        "icon-b_polar",
        "icon-b_ravpower",
        "icon-b_redmi",
        "icon-b_gopro",
        "icon-b_yeelight",
        "icon-b_gimi"
        // "icon-b_yi",
        // "icon-b_sengled",
        // "icon-b_joyetech",
        // "icon-b_momax",
        // "icon-b_pioneer",
        // "icon-b_wismec",
        // "icon-b_fibrum",
      ]
    };
  },
  methods: {
    hideBrands() {
      if ($(window).width() >= 1024) {
        $.fn.fullpage.moveTo("brands", 0);
        setTimeout(function() {
          $('.fp-section[data-anchor="brands"]').removeClass("brands_open");
        }, 300);
      } else {
        $("body").removeClass("brandsIn");
        setTimeout(function() {
          $("body").removeClass("brandsListOpen");
        }, 500);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.pseudo_btns {
  position: fixed;
  top: 290px;
  left: 60px;
  z-index: 100;
  display: none;

  @media (min-width: 1600px) {
    left: 90px;
  }
}

@media (min-width: 1024px) {
  body.hideHeader .pseudo_btns {
    display: block;
  }
}

.pseudo_btn {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: rgba(#808080, 0.3);
  line-height: 40px;
  display: inline-block;
  text-align: center;
}

.br_list_title {
  margin: 0;
  padding: 100px 20px 0;
  position: relative;
  z-index: 3;

  @media (min-width: 700px) {
    padding: 100px 35px 0;
    margin: 0;
  }

  @media (min-width: 1024px) {
    padding: 120px 0 0 120px;
  }
}

.br_lisr_cont_wrap {
  padding: 20px;
  display: flex;
  flex-flow: wrap;

  @media (min-width: 700px) {
    padding: 35px;
  }

  @media (min-width: 1024px) {
    padding: 30px 120px 0;
  }

  @media (min-width: 1600px) {
    padding: 40px 180px 0;
  }
}

.br_list_wrp {
  position: relative;
  z-index: 3;
}

.brands_screen_vidget {
  background: #f1f1f1;
  width: 100%;
  padding-left: 0;
  position: relative;
  z-index: 120;
  top: 0;

  &:before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 80%;
    content: '';
    background: #FAFBFC;
    -webkit-transition: all 0.4s cubic-bezier(0.25, 0.01, 0.25, 1);
    -moz-transition: all 0.4s cubic-bezier(0.25, 0.01, 0.25, 1);
    transition: all 0.4s cubic-bezier(0.25, 0.01, 0.25, 1);
  }

  @media (min-width: 1024px) {
    width: 100%;
  }
}

.brList.active {
  .brands_screen_vidget {
    &:before {
      -webkit-transition-delay: 0.3s;
      -moz-transition-delay: 0.3s;
      transition-delay: 0.3s;
      left: 0;
    }
  }
}

.backToBrandsScreen {
  width: 325px;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
}

.close_btn {
  display: block;
  position: absolute;
  top: 25px;
  right: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  cursor: pointer;
  z-index: 4;

  &:hover {
    color: #000;
  }

  @media (min-width: 700px) {
    top: 35px;
    right: 35px;
  }

  @media (min-width: 1024px) {
    top: 40px;
    right: 80px;
  }
}

.brnd_item i {
  height: 100%;
  display: block;
}

.icon-b_haylou {
  margin-top: -7px;
  background: url('~@/assets/images/haylou.png') center no-repeat;
}

.icon-b_70mai {
  margin-top: -7px;
  background: url('~@/assets/images/70mai.png') center no-repeat;
}

.icon-b_oclean {
  margin-top: -7px;
  background: url('~@/assets/images/oclean.png') center no-repeat;
}

.icon-b_soocas {
  margin-top: -7px;
  background: url('~@/assets/images/soocas.png') center no-repeat;
}

.icon-b_smartmi {
  margin-top: -7px;
  background: url('~@/assets/images/smartmi.png') center no-repeat;
}

.icon-b_roborock {
  margin-top: -7px;
  background: url('~@/assets/images/roborock.png') center no-repeat;
}

.icon-b_redmi {
  margin-top: -7px;
  background: url('~@/assets/images/redmi.png') center no-repeat;
}

.icon-b_gopro {
  margin-top: -7px;
  background: url('~@/assets/images/gopro.png') center no-repeat;
}

.icon-b_gimi {
  margin-top: -7px;
  background: url('~@/assets/images/svg/gimi.svg') center no-repeat;
}
</style>